import { useSelect } from "@wordpress/data";
import { useState, useEffect } from "@wordpress/element";

export default function topicsbox({ attributes, docSections }) {
    const { articlesNumber, col, docs_layout, docId, excerptCharNumber, isFeaturedImage } = attributes;
    const [exceprtText, setExceprtText] = useState("");

    // Determine layout type
    const layoutType = docs_layout === "grid" ? `ezd-grid ezd-column-${col}` : "ezd-masonry-wrap";

    // Fetch the parent post (docId)
    const post = useSelect((select) => {
        return select("core").getEntityRecord("postType", "docs", docId);
    }, [docId]);

    useEffect(() => {
        if (post) {
            console.log("Post Title:", post.title.rendered);
        } else {
            console.log("Post not found or still loading.");
        }
    }, [post]);

    // Fetch all doc items (child sections) for each section in a single call
    const allDocItems = useSelect((select) => {
        const parentIds = docSections?.map((section) => section.id) || [];
        return parentIds.map((parentId) => ({
            parentId,
            items: select('core').getEntityRecords('postType', 'docs', {
                per_page: articlesNumber,
                order: 'asc',
                parent: parentId,
                status: ['publish', 'private']
            }),
        }));
    }, [articlesNumber, docSections]);

    // Function to show first 'n' words of a sentence
    const showWords = (sentence, numberOfWords) => {
        // Split the sentence into an array of words
        let wordsArray = sentence.split(" ");

        // If the number of words to show is greater than the length of the array, return the original sentence
        if (numberOfWords >= wordsArray.length) {
            return sentence;
        }

        // Slice the array to get the desired number of words and join them back into a string
        let truncatedSentence = wordsArray.slice(0, numberOfWords).join(" ");

        // Return the truncated sentence
        return truncatedSentence;
    };

    // Helper function to get the excerpt or first N words of the content
    const getExcerptOrContent = (content, excerpt) => {
        // Check if excerpt is available and if it has a rendered value
        if (excerpt && excerpt.rendered) {
            let excerptString = excerpt.rendered;
            let updatedExcerptString = excerptString.replace("<p>", "").replace("</p>", "");
            return showWords(updatedExcerptString, excerptCharNumber);
        }
        return "";
    };
    
    // State for all featured media images
    const [images, setImages] = useState({});

    useEffect(() => {
        const fetchImages = async () => {
            if (!Array.isArray(docSections)) {
                return;
            }    
            const imagePromises = docSections.map(async (section) => {
                if (section.featured_media) {
                    try {
                        const media = await wp.apiFetch({ path: `/wp/v2/media/${section.featured_media}` });
                        return { id: section.id, imageUrl: media.source_url };
                    } catch (error) {
                        console.error("Error fetching media:", error);
                        return { id: section.id, imageUrl: null };
                    }
                }
                return { id: section.id, imageUrl: null };
            });    
            const results = await Promise.all(imagePromises);
            const imageMap = results.reduce((acc, { id, imageUrl }) => {
                acc[id] = imageUrl;
                return acc;
            }, {});
            setImages(imageMap);
        };
        
        const safeDocSections = docSections || [];
        fetchImages(safeDocSections);
    }, [docSections]);
    
    return (
        <div className={`ezd-grid ezd-column-${col} h_content_items topic-box-style`}>
            {/* Render sections */}
            {docSections &&
                docSections.map((section) => {
                    const { title, id, excerpt, content, featured_media } = section; // Get excerpt and content for the parent section
                    
                    // State and effect for featured image
                    const imageUrl = images[id];
                    
                    // Get the excerpt or first 'excerptCharNumber' words for the parent section
                    const parentExcerptOrContent = getExcerptOrContent(content.rendered, excerpt);

                    // Find the child items for the current section using its parentId
                    const sectionItems = allDocItems.find((item) => item.parentId === id)?.items || [];

                    return (
                        <a href="#" key={id}>
                            <div className="h_item">   
                                
                                {isFeaturedImage && imageUrl && (
                                    <img src={imageUrl} alt={title.rendered} />
                                )}                             
                          
                                <h4 className="ct-heading-text">{title.rendered}</h4>
                                <div className="ct-content-text">
                                    {/* Display parent section excerpt or content */}
                                    <div>{parentExcerptOrContent}</div>

                                    {/* Render child items */}
                                    {sectionItems && sectionItems.length > 0 && (
                                        sectionItems.map((childItem) => {
                                            // Get the content or excerpt for each child item
                                            const excerptOrContent = getExcerptOrContent(
                                                childItem.excerpt.rendered
                                            );

                                            // Wrap child content in a <div> element
                                            return (
                                                <div key={childItem.id}>{excerptOrContent}</div>
                                            );
                                        })
                                    ) }
                                </div>
                            </div>
                        </a>
                    );
                })}
        </div>
    );
}